import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import { FondoRischiRevisioneFormComponent } from '../../../form/sez-economica/fondo-rischi-revisione-form.component';
import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { PetitumRevisione } from '../../../models/petitum-revisione';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';

@Component({
  selector: 'div [fondo-rischi-revisione-form-add]',
  templateUrl: '../../../form/sez-economica/fondo-rischi-revisione-form.component.html',
})

export class FondoRischiAddRevisioneComponent extends FondoRischiRevisioneFormComponent implements OnInit {
  petitumRevisione: PetitumRevisione;
  urlInsert: string;
  sezione: SezioneEconomica;
  fascicolo: FascicoloFull;
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @Output() onAnnulla: EventEmitter<void> = new EventEmitter<void>();
  @Input() edit: boolean;

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Aggiungi revisione fondo rischi');
    this.isInserimento(true);
  }

  getPetitumRevisione() {
    return this.petitumRevisione;
  }

  getSezione() {
    return this.sezione;
  }

  getRequest(petitumRevisione: PetitumRevisione) {
    console.log(petitumRevisione);
    let idSezione: string = PropertiesSettings.NEW_SEZIONE;
    if (this.sezione) {
      idSezione = this.sezione.id;
    }
    this.operationService.addFondoRischiRevisione(this.urlInsert, petitumRevisione, idSezione, this.fascicolo.id).
      subscribe((response: any) => this.datiResponse(response));
  }

  datiResponse(response: SezioneEconomicaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneEconomica, petitumRevisione: PetitumRevisione, fascicolo: FascicoloFull, urlInsert: string, urlSezioneControparti: string, idSezioneControparti: string, isPercentualeSoccombenza: boolean) {
    this.fascicolo = fascicolo;
    this.sezione = sezione;
    this.urlInsert = urlInsert;
    this.petitumRevisione = petitumRevisione;
    this.createForm(isPercentualeSoccombenza);
    this.populateSelect(urlSezioneControparti, idSezioneControparti);
  }

  closeModal() {
    this.onAnnulla.emit();
  }

  getEdit() {
    return this.edit;
  }
}
